import { ENDPOINTS } from 'utils/api/callApi'
import { ICostControlConfig } from '../../types/costControlConfig'

export enum ADD_COST_CONTROL_CONFIG_MODAL_ACTIONS {
  ADD_COST_CONTROL_CONFIG_MODAL_OPEN = 'ADD_COST_CONTROL_CONFIG_MODAL_OPEN',
  ADD_COST_CONTROL_CONFIG_MODAL_CLOSE = 'ADD_COST_CONTROL_CONFIG_MODAL_CLOSE',
}
export const openAddCostControlConfigModal = (costControlConfig?: ICostControlConfig) => ({
  type: ADD_COST_CONTROL_CONFIG_MODAL_ACTIONS.ADD_COST_CONTROL_CONFIG_MODAL_OPEN,
  payload: { costControlConfig },
})
export const closeAddCostControlConfigModal = () => ({
  type: ADD_COST_CONTROL_CONFIG_MODAL_ACTIONS.ADD_COST_CONTROL_CONFIG_MODAL_CLOSE,
})

export enum DELETE_COST_CONTROL_CONFIG_MODAL_ACTIONS {
  DELETE_COST_CONTROL_CONFIG_MODAL_OPEN = 'DELETE_COST_CONTROL_CONFIG_MODAL_OPEN',
  DELETE_COST_CONTROL_CONFIG_MODAL_CLOSE = 'DELETE_COST_CONTROL_CONFIG_MODAL_CLOSE',
}
export const openDeleteCostControlConfigModal = (costControlConfig: ICostControlConfig) => ({
  type: DELETE_COST_CONTROL_CONFIG_MODAL_ACTIONS.DELETE_COST_CONTROL_CONFIG_MODAL_OPEN,
  payload: { costControlConfig },
})
export const closeDeleteCostControlConfigModal = () => ({
  type: DELETE_COST_CONTROL_CONFIG_MODAL_ACTIONS.DELETE_COST_CONTROL_CONFIG_MODAL_CLOSE,
})

export enum GET_COST_CONTROL_CONFIGS_ACTIONS {
  GET_COST_CONTROL_CONFIGS_REQUEST = 'GET_COST_CONTROL_CONFIGS_REQUEST',
  GET_COST_CONTROL_CONFIGS_SUCCESS = 'GET_COST_CONTROL_CONFIGS_SUCCESS',
  GET_COST_CONTROL_CONFIGS_FAILURE = 'GET_COST_CONTROL_CONFIGS_FAILURE',
}
export const getCostControlConfigs = () => ({
  payload: {
    callApi: true,
    requestData: {
      endpoint: ENDPOINTS.costControlConfigs,
      method: 'GET',
    },
    actionTypes: Object.keys(GET_COST_CONTROL_CONFIGS_ACTIONS),
  },
  type: '',
})

export enum CREATE_COST_CONTROL_CONFIG_ACTIONS {
  CREATE_COST_CONTROL_CONFIG_REQUEST = 'CREATE_COST_CONTROL_CONFIG_REQUEST',
  CREATE_COST_CONTROL_CONFIG_SUCCESS = 'CREATE_COST_CONTROL_CONFIG_SUCCESS',
  CREATE_COST_CONTROL_CONFIG_FAILURE = 'CREATE_COST_CONTROL_CONFIG_FAILURE',
}
export const createCostControlConfig = (costControlConfig: ICostControlConfig) => ({
  payload: {
    callApi: true,
    requestData: {
      endpoint: ENDPOINTS.costControlConfigs,
      method: 'POST',
      body: { costControlConfig },
    },
    actionTypes: Object.keys(CREATE_COST_CONTROL_CONFIG_ACTIONS),
  },
  type: '',
})

export enum UPDATE_COST_CONTROL_CONFIG_ACTIONS {
  UPDATE_COST_CONTROL_CONFIG_REQUEST = 'UPDATE_COST_CONTROL_CONFIG_REQUEST',
  UPDATE_COST_CONTROL_CONFIG_SUCCESS = 'UPDATE_COST_CONTROL_CONFIG_SUCCESS',
  UPDATE_COST_CONTROL_CONFIG_FAILURE = 'UPDATE_COST_CONTROL_CONFIG_FAILURE',
}
export const updateCostControlConfig = (costControlConfig: ICostControlConfig) => ({
  payload: {
    callApi: true,
    requestData: {
      endpoint: ENDPOINTS.costControlConfigs,
      method: 'PUT',
      id: costControlConfig.id,
      body: { costControlConfig },
    },
    actionTypes: Object.keys(UPDATE_COST_CONTROL_CONFIG_ACTIONS),
  },
  type: '',
})

export enum DELETE_COST_CONTROL_CONFIG_ACTIONS {
  DELETE_COST_CONTROL_CONFIG_REQUEST = 'DELETE_COST_CONTROL_CONFIG_REQUEST',
  DELETE_COST_CONTROL_CONFIG_SUCCESS = 'DELETE_COST_CONTROL_CONFIG_SUCCESS',
  DELETE_COST_CONTROL_CONFIG_FAILURE = 'DELETE_COST_CONTROL_CONFIG_FAILURE',
}
export const deleteCostControlConfig = (configId?: string) => ({
  payload: {
    callApi: true,
    requestData: {
      endpoint: ENDPOINTS.costControlConfigs,
      method: 'DELETE',
      id: configId,
    },
    actionTypes: Object.keys(DELETE_COST_CONTROL_CONFIG_ACTIONS),
  },
  type: '',
})
